import { render, staticRenderFns } from "./app-main-layout.vue?vue&type=template&id=074c597a&scoped=true&"
import script from "./app-main-layout.vue?vue&type=script&lang=js&"
export * from "./app-main-layout.vue?vue&type=script&lang=js&"
import style0 from "./app-main-layout.vue?vue&type=style&index=0&id=074c597a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c597a",
  null
  
)

export default component.exports